import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c343e076"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "orangehrm-background-container my-payslips" }
const _hoisted_2 = { class: "paper" }
const _hoisted_3 = { class: "page-heading" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "My Payslips"),
  /*#__PURE__*/_createElementVNode("p", null, "Published payslips for your payroll periods.")
], -1))
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "error"
}
const _hoisted_7 = { class: "payslip-list" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "empty"
}
const _hoisted_10 = {
  key: 1,
  class: "slip"
}
const _hoisted_11 = { class: "brand-header" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "brand-company" }, [
  /*#__PURE__*/_createElementVNode("b", null, "EMPLOYEE PAYROLL"),
  /*#__PURE__*/_createElementVNode("span", null, "www.connexix.com")
], -1))
const _hoisted_14 = { class: "slip-banner" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "EMPLOYEE PAYSLIP", -1))
const _hoisted_16 = { class: "pay-period" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "PAY PERIOD", -1))
const _hoisted_18 = { class: "slip-section employee-section" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "EMPLOYEE DETAILS", -1))
const _hoisted_20 = { class: "employee-grid" }
const _hoisted_21 = { class: "employee-cell" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "EMPLOYEE", -1))
const _hoisted_23 = { class: "employee-cell" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "EMPLOYEE ID", -1))
const _hoisted_25 = { class: "employee-cell" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "DEPARTMENT", -1))
const _hoisted_27 = { class: "employee-cell" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "DESIGNATION", -1))
const _hoisted_29 = { class: "employee-cell" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "PAYMENT MODE", -1))
const _hoisted_31 = { class: "employee-cell" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "PAYMENT MONTH", -1))
const _hoisted_33 = { class: "slip-section breakdown-section" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "PAY BREAKDOWN", -1))
const _hoisted_35 = { class: "breakdown-grid" }
const _hoisted_36 = { class: "breakdown-card earnings-card" }
const _hoisted_37 = { class: "breakdown-heading" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "EARNINGS", -1))
const _hoisted_39 = { class: "line gross-line" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Gross pay", -1))
const _hoisted_41 = { class: "breakdown-card deductions-card" }
const _hoisted_42 = { class: "breakdown-heading" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "DEDUCTIONS", -1))
const _hoisted_44 = { class: "line gross-line" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Total deductions", -1))
const _hoisted_46 = { class: "net-pay" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", null, "NET PAY"),
  /*#__PURE__*/_createElementVNode("span", null, "Amount payable after deductions")
], -1))
const _hoisted_48 = {
  key: 0,
  class: "slip-section commission-details"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "SALES COMMISSION CONVERSION", -1))
const _hoisted_50 = { class: "employee-grid" }
const _hoisted_51 = { class: "employee-cell" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "USD SALES REVENUE", -1))
const _hoisted_53 = { class: "employee-cell" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "COMMISSION RATE", -1))
const _hoisted_55 = { class: "employee-cell" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "USD → PKR RATE", -1))
const _hoisted_57 = { class: "slip-section payment-section" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "PAYMENT DETAILS", -1))
const _hoisted_59 = { class: "payment-grid" }
const _hoisted_60 = { class: "employee-cell" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "BANK", -1))
const _hoisted_62 = { class: "employee-cell" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "ACCOUNT", -1))
const _hoisted_64 = { class: "employee-cell" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "PAYMENT MODE", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", { class: "slip-footer" }, [
  /*#__PURE__*/_createElementVNode("p", null, " This is a computer-generated payslip and does not require a handwritten signature. This document contains confidential payroll information and is intended only for the named employee. "),
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createTextVNode("CONNEXIX "),
    /*#__PURE__*/_createElementVNode("span", null, "-"),
    /*#__PURE__*/_createTextVNode(" www.connexix.com")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("button", {
          class: "print-button",
          disabled: !_ctx.selected,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadSlip && _ctx.downloadSlip(...args)))
        }, " Download PDF ", 8, _hoisted_5)
      ]),
      (_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.errorMessage), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slips, (item) => {
          return (_openBlock(), _createElementBlock("button", {
            key: item.id,
            class: _normalizeClass({active: _ctx.selected?.id === item.id}),
            onClick: ($event: any) => (_ctx.open(item))
          }, _toDisplayString(_ctx.period(item.period_start)) + " · Net " + _toDisplayString(_ctx.money(item.net)), 11, _hoisted_8))
        }), 128)),
        (_ctx.slips.length === 0 && !_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, " No published payslips are available. "))
          : _createCommentVNode("", true)
      ]),
      (_ctx.selected)
        ? (_openBlock(), _createElementBlock("article", _hoisted_10, [
            _createElementVNode("header", _hoisted_11, [
              _createElementVNode("img", {
                src: _ctx.connexixLogo,
                alt: "Connexix"
              }, null, 8, _hoisted_12),
              _hoisted_13
            ]),
            _createElementVNode("section", _hoisted_14, [
              _createElementVNode("div", null, [
                _hoisted_15,
                _createElementVNode("p", null, "Payroll statement · " + _toDisplayString(_ctx.period(_ctx.selected.period_start)), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("span", null, _toDisplayString(_ctx.dateLabel(_ctx.selected.period_start)) + " - " + _toDisplayString(_ctx.dateLabel(_ctx.selected.period_end)), 1)
              ])
            ]),
            _createElementVNode("section", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("span", null, _toDisplayString(_ctx.fullName), 1)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("span", null, _toDisplayString(_ctx.selected.employee_id), 1)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("span", null, _toDisplayString(_ctx.selected.department || '—'), 1)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("span", null, _toDisplayString(_ctx.selected.designation || '—'), 1)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("span", null, _toDisplayString(_ctx.paymentMode), 1)
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _createElementVNode("span", null, _toDisplayString(_ctx.period(_ctx.selected.period_start)), 1)
                ])
              ])
            ]),
            _createElementVNode("section", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createElementVNode("b", null, "AMOUNT (" + _toDisplayString(_ctx.selected.currency || 'PKR') + ")", 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.earnings, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.name,
                      class: "line"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(item.name), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.money(item.amount)), 1)
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _createElementVNode("b", null, _toDisplayString(_ctx.money(_ctx.selected.gross)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _hoisted_43,
                    _createElementVNode("b", null, "AMOUNT (" + _toDisplayString(_ctx.selected.currency || 'PKR') + ")", 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deductions, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.name,
                      class: "line"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(item.name), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.money(item.amount)), 1)
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_44, [
                    _hoisted_45,
                    _createElementVNode("b", null, _toDisplayString(_ctx.money(_ctx.selected.total_deductions)), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("section", _hoisted_46, [
              _hoisted_47,
              _createElementVNode("strong", null, _toDisplayString(_ctx.selected.currency || 'PKR') + " " + _toDisplayString(_ctx.money(_ctx.selected.net)), 1)
            ]),
            (Number(_ctx.selected.sales_revenue_usd) > 0)
              ? (_openBlock(), _createElementBlock("section", _hoisted_48, [
                  _hoisted_49,
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _hoisted_52,
                      _createElementVNode("span", null, "USD " + _toDisplayString(_ctx.money(_ctx.selected.sales_revenue_usd)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _hoisted_54,
                      _createElementVNode("span", null, _toDisplayString(_ctx.selected.commission_rate) + "%", 1)
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _hoisted_56,
                      _createElementVNode("span", null, _toDisplayString(_ctx.money(_ctx.selected.usd_pkr_rate)), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("section", _hoisted_57, [
              _hoisted_58,
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _hoisted_61,
                  _createElementVNode("span", null, _toDisplayString(_ctx.selected.bank_name || '—'), 1)
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _hoisted_63,
                  _createElementVNode("span", null, _toDisplayString(_ctx.maskedAccount), 1)
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _hoisted_65,
                  _createElementVNode("span", null, _toDisplayString(_ctx.paymentMode), 1)
                ])
              ])
            ]),
            _hoisted_66
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}